const AVAILABLE_LEGAL_DOCUMENT_LOCALES = [
  'es',
  'en',
  'fr',
  'it',
  'pt',
];

function normalizeLocale(locale) {
  return (locale || '').substring(0, 2).toLowerCase();
}

export function getLegalDocumentsLocale(preferredLocale) {
  const normalizedPreference = normalizeLocale(preferredLocale);
  if (
    AVAILABLE_LEGAL_DOCUMENT_LOCALES.includes(normalizedPreference)
  ) {
    return normalizedPreference;
  }

  if (typeof navigator === 'undefined') return 'es';

  const browserLocale = normalizeLocale(navigator.language);

  return AVAILABLE_LEGAL_DOCUMENT_LOCALES.includes(browserLocale)
    ? browserLocale
    : 'es';
}

export default AVAILABLE_LEGAL_DOCUMENT_LOCALES;
